import config from "@/core/config/layout.config.json";
import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";
export * from "./types";

export default {
  state: {
    config: config,
    initial: config,
  },
  getters,
  actions,
  mutations,
};
